import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Skeleton, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import StyledModal from './styleModal';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'ReducerState';
import { isEmpty } from 'validator';
import { userSignOut } from 'appRedux/actions/Auth'
import { licenseRequest } from "appRedux/actions/license"

const TagWarning: React.FC = () => {
  const [open, setOpen] = useState(false);

  const { license_info, loading } = useSelector((state: AppState) => state.license)
  const dispatch = useDispatch()
  const firstLoad = useRef(true)

  useEffect(() => {
    if (firstLoad.current) {
      setTimeout(() => {
        dispatch(licenseRequest())
      }, 500);
      firstLoad.current = false
    }
    return () => {
      firstLoad.current = true
    }
  }, [firstLoad])

  useEffect(() => {
    if (license_info?.active === false)
      setOpen(true)
  }, [license_info])

  useEffect(() => {
    if (open) {
      dispatch(licenseRequest())
    }
  }, [open])


  const warningMessage = useMemo(() => {
    if (!license_info) return '';
    const { warning, warning_message } = license_info as any;
    if (warning) return warning_message || '';
    return '';
  }, [license_info]);

  const LicenseTitle: string = license_info?.warning_title
    ? license_info?.warning_title
    : 'License Warning';

  const onHandleLink = () => {
    if (license_info?.renew_link_url) {
      window.open(license_info.renew_link_url, '_blank');
    }
  };

  const handleClose = () => {
    setOpen(false)
    if (license_info.active === false)
      dispatch(userSignOut())
    else
      dispatch(licenseRequest())
  }

  if (isEmpty(warningMessage)) return null;

  return (
    <>
      <Tooltip title={LicenseTitle} className='blink'>
        <span
          role='button'
          onClick={() => setOpen(true)}
          style={{
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            marginLeft: 10,
            marginRight: 10,
          }}
        >
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            style={{
              color: '#f03e3e',
              fontSize: 18,
              filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.15))',
            }}
          />
        </span>
      </Tooltip>
      <StyledModal
        title={LicenseTitle}
        open={open}
        onOk={handleClose}
        onCancel={handleClose}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={520}
      >
        <Skeleton loading={loading}>
          <span className='warning-message'>{warningMessage}</span>
          {license_info?.renew_link_url && (
            <div className='link-renew'>
              <span onClick={onHandleLink}>{license_info?.renew_link_text}</span>
            </div>
          )}
        </Skeleton>
      </StyledModal>
    </>
  );
};

export default TagWarning;
